import React, { memo, useEffect, useState, useRef } from 'react';
import $, { event } from 'jquery';
import { CFS, MD5 } from '../utils/common';
import { dispatchAlert } from '../utils/site-utils';
import { trim, emailCheck, isNumberFormat, isPhoneFormat, GetQueryString, getFullUrlPath } from '../utils/common';
import Label from '../utils/label';
import Config from '../utils/config';
import { isdate, CheckAge } from '../utils/depositComm';
import { getCookie, setCookie } from '../utils/cookie';

const _SiteId = Config.appConfig.SiteID;
const isAudit = _SiteId == '4240700' || _SiteId == '4245600';
const is12B = _SiteId == '4240700';

const OptionItem = props => {
	const onClick = () => {
		props.onClick(props.type, props.id, props.text);
	};

	return (
		<li value={props.id} title={props.text} onClick={onClick} dangerouslySetInnerHTML={{ __html: props.text }} >
		</li>
	);
};

export default class PopupSignup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showSQOption: 'hidden',
			showMonthOption: 'hidden',
			showDayOption: 'hidden',
			showYearOption: 'hidden',
			showCountryOption: 'hidden',
			showCurrencyOption: 'hidden',
			showOddsOption: 'hidden',
			showBankNameOption: 'hidden',
			showBankCountryOption: 'hidden',
			// 12B 新增
			showOccupationOption: 'hidden',
			showSourceFundsOption: 'hidden',
			lbl_Address: '',
			lbl_Occupation: '',
			lbl_SourceofFunds: '',
			SQ: Label.lbl_SelectOne,
			Country: Label.lbl_SelectOne,
			Currency: Label.lbl_SelectOne,
			Odds: Label.lbl_SelectOne,
			BankName: Label.lbl_SelectOne,
			BankCountry: Label.lbl_SelectOne,
			displaySecuritycode: true,
			displaySecurityAnswer: true,
			displayDateofbirth: '',
			styleMy_Country: true,
			styleMy_Preferred_currency: true,
			styleMy_Preferred_odds: true,
			DisCtl_Bonus: false,
			FirstNameStyle: false,
			LastNameStyle: false,
			BankNameStyle: false,
			BankAddressStyle: false,
			BankCountryStyle: false,
			BranchStyle: false,
			CanSeeAccountName: false,
			AccountNumberStyle: false,
			BankSwiftStyle: false,
			BankCorrBankStyle: false,
			FundoutBankDetail: false,
			DisCtl_BankDetail: 'hidden',
			displayWhereToKnow: false,
			DisCtl_AgentCode: false,
			Month: '',
			Day: '',
			Year: '',
			markFirstName: '',
			markLastName: '',
			markBankName: '',
			markBankAddress: '',
			markBankCountry: '',
			markBranch: '',
			markAccountName: '',
			markBankAccoun: '',
			markBank_swift: '',
			markCorrespondingBank: '',
			lbl_OpenAccount: '',
			lbl_Preferred_username: '',
			lbl_checkusername: '',
			lbl_password: '',
			lbl_confirmpassword: '',
			lbl_Securitycode: '',
			lbl_SecurityAnswer: '',
			lbl_execlastname: '',
			lbl_firstname: '',
			lbl_lastname: '',
			lbl_Dateofbirth: '',
			lbl_Country: '',
			lbl_email: '',
			lbl_Primaryphone: '',
			lbl_My_Preferred_currency: '',
			lbl_My_Preferred_odds: '',
			lbl_BonusCode: '',
			lbl_BankCountry: '',
			lbl_code: '',
			lbl_regNote1: '',
			lbl_regNote4: '',
			lbl_regNote5: '',
			lbl_regNote6: '',
			lbl_BankName: '',
			lbl_BankAddress: '',
			lbl_Branch: '',
			lbl_BankAccountNumber: '',
			lbl_BankSwift: '',
			lbl_AccountName: '',
			lbl_Corresponding: '',
			lbl_WhereToKnowMsg: '',
			lbl_AgentCode: '',
			lbl_SelectYear: '',
			lbl_SelectMonth: '',
			lbl_SelectDay: '',
			txtWhereToKnow: '',
			txtAgentCode: '',
			txtUserName: '',
			txtPassword: '',
			txtConfirmPassword: '',
			txtSQ: '',
			txtQuestionCode: '',
			txtMonth: '',
			txtDay: '',
			txtYear: '',
			txtCountry: '',
			txtCurrency: '',
			txtOdds: '',
			txtFirstName: '',
			txtLastName: '',
			txtAddress: '',
			txtEmail: '',
			txtPhone: '',
			txtBonusCode: '',
			txtBankName: '',
			txtBankAddress: '',
			txtBankCountry: '',
			txtBranch: '',
			txtAccountName: '',
			txtBank_swift: '',
			txtCorresponding_Bank: '',
			txtValidation: '',
			txtBankAccount: '',
			CheckTerm: '',
			bNameData: [],
			SubmitStyle: '',
			AffID: '',
			ClickID: '',
			sqOptionsItems: [],
			monthOptionsItems: [],
			dayOptionsItems: [],
			yearOptionsItems: [],
			countryOptionsItems: [],
			currencyOptionsItems: [],
			OccupationOptionItems: [],
			FundsOptionsItems: [],
			oddsOptionsItems: [],
			bNameOptionsItems: [],
			bCountryOptionsItems: [],
			txtOccupation: '',
			txtSourceFunds: '',
			CurrentOccupationId: '',
			CurrentSourceFundsId: '',
			ShowOccupationOtherText: false,
			ShowSourceFundsOtherText: false,
			lbl_OtherOption: '',
			lbl_SourceFunds: '',
			txtOccupationOther: '',
			txtSourceFundsOther: '',
			lbl_Limit50: '',
			lbl_limit200: '',
			KycFile: '',
			KycFileInfo: {
				preview: '',
				name: '',
				size: ''
			},
			KycfileError: false,
			KycfileErrorMessage: '',
			lbl_RegistrationField27: '',
			lbl_RegistrationField28: '',
			lbl_RegistrationField29: '',
			lbl_RegistrationField30: '',
			lbl_RegistrationField31: '',
			lbl_RegistrationField32: '',
			lbl_RegistrationField33: '',
			lbl_RegistrationField34: '',
			lbl_RegistrationField35: '',
			lbl_RegistrationField36: '',
			lbl_RegistrationField37: '',
			lbl_RegistrationField38: '',
			lbl_RegistrationField39: '',
			lbl_RegistrationField40: '',
		};
		this.KycFileInputRef = React.createRef();
	}



	handleInputChange = event => {
		const target = event.target;
		if (target.id === "txtBankAccount" && !isNumberFormat(target.value)) {
			return;
		}
		else if (target.id === "txtPrimary_phone" && !isPhoneFormat(target.value)) {
			return;
		}
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = event.target.name;

		this.setState({
			[name]: value
		});
	};

	senRegister = () => {
		if (_SiteId == '4215600') {
			try {
				ga('send', 'event', 'Home', 'Button_Click', 'Registration_Submit');
			} catch (error) { }
		}
		// var self = this;
		this.setState({ SubmitStyle: 'disabled' });
		const hasError = false;
		const re1 = new RegExp(/[a-zA-Z0-9]{6,}/);
		const reName = new RegExp(/[a-zA-Z0-9\-\,\.]{1,50}/);
		let spriltarry;
		//Preferred_username
		const uname = trim(this.state.txtUserName);
		if (!uname) {
			dispatchAlert(`${this.state.lbl_Preferred_username} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		const CheckStr = '__';
		const CheckRule = uname.indexOf(CheckStr);
		if (CheckRule != -1) {
			dispatchAlert(`${this.state.lbl_Preferred_username} ${Label.lbl_Worngfromat}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (uname.length < 5) {
			dispatchAlert(`${this.state.lbl_Preferred_username} ${Label.lbl_limitUserName}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		//password
		let password = trim(this.state.txtPassword);
		if (!password) {
			dispatchAlert(`${this.state.lbl_password} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (password.length < 6 || password.length > 10) {
			dispatchAlert(`${this.state.lbl_password} ${Label.lbl_execPassword}`);
			this.setState({ SubmitStyle: '' });
			return;
		}

		spriltarry = re1.exec(password);
		if (spriltarry == null) {
			dispatchAlert(`${this.state.lbl_password} ${Label.lbl_execPassword}`);
			this.setState({ SubmitStyle: '' });
			return;
		} else {
			if (spriltarry.index == 0) {
				if (spriltarry[0] != password) {
					dispatchAlert(`${this.state.lbl_password} ${Label.lbl_execPassword}`);
					this.setState({ SubmitStyle: '' });
					return;
				}
			} else {
				dispatchAlert(`${this.state.lbl_password} ${Label.lbl_execPassword}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
		}
		// Confirm Password
		let ConfirmPassword = trim(this.state.txtConfirmPassword);
		if (!ConfirmPassword) {
			dispatchAlert(`${this.state.lbl_confirmpassword} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (ConfirmPassword.length < 6) {
			dispatchAlert(`${this.state.lbl_confirmpassword} ${Label.lbl_execPassword}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (ConfirmPassword.length > 10) {
			dispatchAlert(`${this.state.lbl_confirmpassword} ${Label.lbl_execPassword}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (password != ConfirmPassword) {
			dispatchAlert(Label.lbl_Passworddifferent);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (isAudit) {
			const CurrentOccupationId = this.state.CurrentOccupationId
			const CurrentSourceFundsId = this.state.CurrentSourceFundsId
			if (this.state.txtOccupation.length == 0) {
				dispatchAlert(`${this.state.lbl_Occupation} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (this.state.txtSourceFunds.length == 0) {
				dispatchAlert(`${this.state.lbl_SourceofFunds}  ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (this.state.txtOccupation.length > 50) {
				dispatchAlert(`${this.state.lbl_Occupation} ${this.state.lbl_Limit50}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (this.state.txtSourceFunds.length > 50) {
				dispatchAlert(`${this.state.lbl_SourceofFunds} ${this.state.lbl_Limit50}`);
				this.setState({ SubmitStyle: '' });
				return;
			}

			if (CurrentOccupationId == 'others') {
				if (this.state.txtOccupationOther.length == 0) {
					dispatchAlert(`${this.state.lbl_Occupation} ${Label.lbl_EmptyInput}`);
					this.setState({ SubmitStyle: '' });
					return;
				}
				else if (this.state.txtOccupationOther.length > 50) {
					dispatchAlert(`${this.state.lbl_Occupation} ${this.state.lbl_Limit50}`);
					this.setState({ SubmitStyle: '' });
					return;
				}

			}
			if (CurrentSourceFundsId == 'others') {
				if (this.state.txtSourceFundsOther.length == 0) {
					dispatchAlert(`${this.state.lbl_SourceofFunds} ${Label.lbl_EmptyInput}`);
					this.setState({ SubmitStyle: '' });
					return;
				}
				else if (this.state.txtSourceFundsOther.length > 50) {
					dispatchAlert(`${this.state.lbl_SourceofFunds} ${this.state.lbl_Limit50}`);
					this.setState({ SubmitStyle: '' });
					return;
				}

			}

			if (this.state.txtAddress.length == 0) {
				dispatchAlert(`${this.state.lbl_Address}  ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			else if (this.state.txtAddress.length > 200) {
				dispatchAlert(`${this.state.lbl_Address}  ${this.state.lbl_limit200}`);
				this.setState({ SubmitStyle: '' });
				return;
			}

			if (!this.state.KycFile || this.state.KycFile === '') {
				dispatchAlert(`${this.state.lbl_RegistrationField39}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
		}
		spriltarry = re1.exec(ConfirmPassword);
		if (spriltarry == null) {
			dispatchAlert(`${this.state.lbl_confirmpassword} ${Label.lbl_execPassword}`);
			this.setState({ SubmitStyle: '' });
			return;
		} else {
			if (spriltarry.index == 0) {
				if (spriltarry[0] != ConfirmPassword) {
					dispatchAlert(`${this.state.lbl_confirmpassword} ${Label.lbl_execPassword}`);
					this.setState({ SubmitStyle: '' });
					return;
				}
			} else {
				dispatchAlert(`${this.state.lbl_confirmpassword} ${Label.lbl_execPassword}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
		}
		let selSecurityQId = this.state.txtSQ;
		if (this.state.displaySecuritycode) {
			if (!selSecurityQId) {
				dispatchAlert(`${this.state.lbl_Securitycode} ${Label.lbl_NotSelect}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
		} else {
			selSecurityQId = 1;
		}
		//SecurityQuestionCode
		if (this.state.displaySecurityAnswer && !trim(this.state.txtQuestionCode)) {
			dispatchAlert(`${this.state.lbl_SecurityAnswer} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		// first Name
		if (this.state.FirstNameStyle && !trim(this.state.txtFirstName)) {
			dispatchAlert(`${this.state.lbl_firstname} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}

		let birMonth = this.state.txtMonth,
			birDay = this.state.txtDay,
			birYear = this.state.txtYear;

		if (this.state.displayDateofbirth == '') {
			//Date of Birthday
			if (!this.state.txtMonth || !this.state.txtDay || !this.state.txtYear) {
				dispatchAlert(`${this.state.lbl_Dateofbirth} ${Label.lbl_NotSelect}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			// Check Date
			const regBirthday = this.state.txtMonth + '/' + this.state.txtDay + '/' + this.state.txtYear;
			if (!isdate(regBirthday)) {
				dispatchAlert(`${this.state.lbl_Dateofbirth} ${Label.lbl_Worngfromat}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (_SiteId == "4218400") {
				if (!CheckAge(regBirthday, 21)) {
					dispatchAlert(Label.lbl_IvoryBetAge21Check);
					this.setState({ SubmitStyle: '' });
					return;
				}
			}
			else if (isAudit) {
				if (!CheckAge(regBirthday, 21)) {
					dispatchAlert(Label.lbl_IvoryBetAge21Check);
					this.setState({
						SubmitStyle: '',
						Month: this.state.lbl_SelectMonth,
						Day: this.state.lbl_SelectDay,
						Year: this.state.lbl_SelectYear,
						txtYear: '',
						txtMonth: '',
						txtDay: '',
					});
					return;
				}
			}
			else {
				if (!CheckAge(regBirthday, 18)) {
					dispatchAlert(`${this.state.lbl_Dateofbirth} ${Label.lbl_NotOver18}`);
					this.setState({ SubmitStyle: '' });
					return;
				}
			}
		} else {
			birMonth = '1';
			birDay = '1';
			birYear = '1990';
		}
		//selCountry
		if (this.state.styleMy_Country && !this.state.txtCountry) {
			dispatchAlert(`${this.state.lbl_Country} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		//Email_address
		const uemail = trim(this.state.txtEmail);
		if (!uemail) {
			dispatchAlert(`${this.state.lbl_email} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (!emailCheck(uemail)) {
			dispatchAlert(`${this.state.lbl_email} ${Label.lbl_Worngfromat}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		const strStopCredited_Country = 'BY,AM,RU,UA';
		//lbl_Primaryphone
		if (!trim(this.state.txtPhone)) {
			dispatchAlert(`${this.state.lbl_Primaryphone} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (!isPhoneFormat(this.state.txtPhone)) {
			dispatchAlert(`${this.state.lbl_Primaryphone} ${Label.lbl_Worngfromat}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		//Currency
		if (this.state.styleMy_Preferred_currency && !this.state.txtCurrency) {
			dispatchAlert(`${this.state.lbl_My_Preferred_currency} ${Label.lbl_NotSelect}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		//odds
		if (this.state.styleMy_Preferred_odds && !this.state.txtOdds) {
			dispatchAlert(`${this.state.lbl_My_Preferred_odds} ${Label.lbl_NotSelect}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		//lbl_WhereToKnowMsg aoncash, M8bola, NBCbet, Q8Bola, UnoBet
		if ((_SiteId == "4202100" || _SiteId == "4209400" || _SiteId == "4211900" || _SiteId == "4210200" || _SiteId == "4212800") && !trim(this.state.txtWhereToKnow)) {
			dispatchAlert(`${this.state.lbl_WhereToKnowMsg} ${Label.lbl_EmptyInput}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		//Bank Detail
		let accountnumber = '';
		if (!this.state.DisCtl_BankDetail) {
			if (!trim(this.state.txtBankName)) {
				dispatchAlert(`${this.state.lbl_BankName} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (
				this.state.BankAddressStyle &&
				this.state.BankAddress_Required &&
				!trim(this.state.txtBankAddress)
			) {
				dispatchAlert(`${this.state.lbl_BankAddress} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (
				this.state.BankCountryStyle &&
				this.state.BankCountry_Required &&
				!trim(this.state.txtBankCountry)
			) {
				dispatchAlert(`${this.state.lbl_BankCountry} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (this.state.BranchStyle && this.state.Branch_Required && !trim(this.state.txtBranch)) {
				dispatchAlert(`${this.state.lbl_Branch} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (!trim(this.state.txtAccountName)) {
				dispatchAlert(`${this.state.lbl_AccountName} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (!trim(this.state.txtBankAccount)) {
				dispatchAlert(`${this.state.lbl_BankAccountNumber} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			if (this.state.BankSwiftStyle && this.state.BankSwift_Required && !trim(this.state.txtBank_swift)) {
				dispatchAlert(`${this.state.lbl_BankSwift} ${Label.lbl_EmptyInput}`);
				this.setState({ SubmitStyle: '' });
				return;
			}
			accountnumber = this.state.txtBankAccount;
		}
		if (!trim(this.state.txtValidation)) {
			dispatchAlert(Label.lbl_Validtionempty);
			this.setState({ SubmitStyle: '' });
			return;
		}
		if (!this.state.CheckTerm) {
			dispatchAlert(`${Label.lbl_Termandconditions} ${Label.lbl_NotAgree}`);
			this.setState({ SubmitStyle: '' });
			return;
		}
		const validatecode = trim(this.state.txtValidation);

		//licBonusCode
		let licBonusCode = this.props.bonusCode;

		let CFSKey;
		let EnCryptData;
		//encrypt password by CFS funcion
		CFSKey = CFS(password);
		EnCryptData = MD5(CFSKey + validatecode);
		const RegisterData = {
			'UserName': trim(this.state.txtUserName),
			'UserPwd': trim(CFS(this.state.txtPassword)),
			'FirstName': trim(this.state.txtFirstName),
			'LastName': trim(this.state.txtLastName),
			'Country': this.state.txtCountry,
			'Phone': trim(this.state.txtPhone),
			'Email': trim(this.state.txtEmail),
			'BirthYear': birYear,
			'BirthMonth': birMonth,
			'BirthDay': birDay,
			'Currency': this.state.txtCurrency,
			'OddsType': this.state.txtOdds,
			'BonusCode': trim(this.state.txtBonusCode),
			'SecurityQID': selSecurityQId,
			'SecurityCode': trim(this.state.txtQuestionCode),
			'CustomInfo1': trim(this.state.txtWhereToKnow),
			'ClickID': this.state.ClickID,
			'LicBonusCode': licBonusCode,
			'Address': trim(this.state.txtAddress),
		};
		const LicBankDetail = {
			'BankName': trim(this.state.txtBankName),
			'BnakAddress': trim(this.state.txtBankAddress),
			'BankCountry': this.state.txtBankCountry,
			'BankAccount': trim(this.state.txtBankAccount),
			'BankBranch': trim(this.state.txtBranch),
			'BankAccountName': trim(this.state.txtAccountName),
			'BankSwiftCode': trim(this.state.txtBank_swift),
			'BankCorresponding': trim(this.state.txtCorresponding_Bank),
		};
		$.ajax({
			type: 'post',
			contentType: 'application/json',
			url: getFullUrlPath('Register/PostRegistration'),
			data: JSON.stringify({
				RegisterData: RegisterData,
				LicBankDetail: LicBankDetail,
				'ValidationCode': trim(this.state.txtValidation),
				'AgentCode': trim(this.state.txtAgentCode),
				'AffID': this.state.AffID,
				'EnCodeUserPwd': trim(EnCryptData),
				'mgid_c': GetQueryString('mgid_c'),
				'mgid_r': GetQueryString('mgid_r'),
				'Occupation': trim(this.state.txtOccupation),
				'SourceFunds': trim(this.state.txtSourceFunds),
				'OtherOccupation': trim(this.state.txtOccupationOther),
				'OtherSourceFunds': trim(this.state.txtSourceFundsOther),
				'KycFile': trim(this.state.KycFile)
			}),
			dataType: "text",
			async: false,
			cache: false,
			success: msg => {
				console.log(msg);
				if (msg) {
					msg = JSON.parse(msg);
					if (msg.ErrorCode === '' || msg.ErrorCode === '0') {
						//this.popupDiv(3);
						setCookie("popupCongSeq", msg.seq);
						window.location.href = msg.url;
					} else {
						dispatchAlert(`${msg.ErrorCode}:${msg.ErrorMsg}`);
					}
				} else {
					console.error(msg);
				}
			},
			error: (jqXHR, textStatus, errorThrown) => {

				console.error(jqXHR, textStatus, errorThrown);
			}
		});
	}

	checkUserName = type => {
		// var self = this;
		const uname = this.state.txtUserName;
		if (uname == '' || uname == undefined) {
			dispatchAlert(`${this.state.lbl_Preferred_username} ${Label.lbl_EmptyInput}`);
		} else if (uname.length < 5) {
			dispatchAlert(`${this.state.lbl_Preferred_username} ${Label.lbl_limitUserName}`);
		} else {
			// var self = this;
			$.ajax({
				url: getFullUrlPath('CheckUserName.aspx?UName=' + uname),
				async: false,
				success: msg => dispatchAlert(msg)
			});
		}
	}

	popupDiv(type) {
		this.props.popupDiv(type);
	}

	onSelectClick = (key, id, text) => {
		this.setState({
			[`txt${key}`]: id,
			[key]: text,
			[`show${key}Option`]: 'hidden'
		}, () => {

			if (isAudit && ['Year', 'Month', 'Day'].includes(key)) {

				const year = this.state.txtYear;
				const month = this.state.txtMonth;
				const day = this.state.txtDay;

				if ([year, month, day].every(value => !!value)) {
					const regBirthday = this.state.txtMonth + '/' + this.state.txtDay + '/' + this.state.txtYear;
					if (!CheckAge(regBirthday, 21)) {
						dispatchAlert(Label.lbl_IvoryBetAge21Check);
						this.setState({
							Month: this.state.lbl_SelectMonth,
							Day: this.state.lbl_SelectDay,
							Year: this.state.lbl_SelectYear,
							txtYear: '',
							txtMonth: '',
							txtDay: '',
						});
					}
				}
			}

			if (isAudit) {
				//Other Option
				if (key == 'Occupation') {
					this.setState({ ShowOccupationOtherText: id == 'others', [`txt${key}`]: text, CurrentOccupationId: id });
					if (!this.state.ShowOccupationOtherText) {
						this.setState({ txtOccupationOther: '' })

					}
				}
				if (key == 'SourceFunds') {
					this.setState({ ShowSourceFundsOtherText: id == 'others', [`txt${key}`]: text, CurrentSourceFundsId: id });
					if (!this.state.ShowSourceFundsOtherText) {
						this.setState({ txtSourceFundsOther: '' })
					}
				}
			}
		});
		if (key == 'Currency') {
			const bNameOptionsItems = [];
			for (let i = 0; i < this.state.bNameData.length; i++) {
				if (this.state.bNameData[i].CurrencyId == id) {
					bNameOptionsItems.push({
						id: this.state.bNameData[i].CurrencyId,
						text: this.state.bNameData[i].BankedIn
					});
				}
			}
			this.setState({ bNameOptionsItems });
			if (_SiteId == '4201800' && id == '20') {
				//macaubet test
				this.setState({ DisCtl_BankDetail: 'hidden' });
			}
		}
	};

	showOptions(key) {
		// eval('this.setState({show' + Key + "Option: ''});");
		this.setState({
			[`show${key}Option`]: ''
		});
	}

	hiddenOptions(key) {
		// eval('this.setState({show' + Key + "Option: 'hidden'});");
		this.setState({
			[`show${key}Option`]: 'hidden'
		});
	}
	handleBrowseClick = () => {
		this.KycFileInputRef.current.click();
	};

	handleFileChange = event => {
		const file = event.target.files[0];
		if (file) {
			const validTypes = ['image/jpeg', 'image/png'];
			const maxSize = 2 * 1024 * 1024;
			if (!validTypes.includes(file.type)) {
				this.setState({
					KycfileError: true,
					KycfileErrorMessage: this.state.lbl_RegistrationField35,
					KycFileInfo: {
						preview: '',
						name: '',
						size: ''
					},
					KycFile: ''
				});
				return;
			} else if (file.size > maxSize) {
				this.setState({
					KycfileError: true,
					KycfileErrorMessage: this.state.lbl_RegistrationField36,
					KycFileInfo: {
						preview: '',
						name: '',
						size: ''
					},
					KycFile: ''
				});
				return;
			}

			const reader = new FileReader();
			reader.onload = (e) => {
				this.setState({
					KycFileInfo: {
						preview: e.target.result,
						name: file.name,
						size: (file.size / 1024 / 1024).toFixed(2) + ' MB'
					},
					KycfileError: false,
					KycfileErrorMessage: '',
					KycFile: e.target.result,
				});
			};

			reader.readAsDataURL(file);
		}
	};

	clearFile = () => {
		this.setState({
			KycFileInfo: {
				preview: '',
				name: '',
				size: ''
			},
			KycFile: '',
			KycfileError: false,
			KycfileErrorMessage: '',
		});
		this.KycFileInputRef.current.value = null;
	};

	componentDidMount() {
		// var self = this;
		$.ajax({
			url: getFullUrlPath('getOption.ashx?setPara=Register'),
			dataType: 'json',
			async: false,
			// TODO: check data Occupation & Source of Funds 
			success: data => {
				console.log('signup data', data);
				const sqOptionsItems = [];
				for (let i = 0; i < data.SQData.length; i++) {
					sqOptionsItems.push({
						id: data.SQData[i].ItemArray[2],
						text: data.SQData[i].ItemArray[1]
					});
				}
				const OccupationOptionsItems = [];
				for (let i = 0; i < data.OccupationOptions.length; i++) {
					OccupationOptionsItems.push({
						id: data.OccupationOptions[i].ItemArray[2],
						text: data.OccupationOptions[i].ItemArray[1]
					});
				}
				const SourceFundsOptionsItems = [];
				for (let i = 0; i < data.SourceFundsOptions.length; i++) {
					SourceFundsOptionsItems.push({
						id: data.SourceFundsOptions[i].ItemArray[2],
						text: data.SourceFundsOptions[i].ItemArray[1]
					});
				}
				const monthOptionsItems = [];
				for (let i = 0; i < data.MonthData.length; i++) {
					monthOptionsItems.push({
						id: data.MonthData[i].ItemArray[2],
						text: data.MonthData[i].ItemArray[1]
					});
				}
				const dayOptionsItems = [];
				for (let i = 0; i < data.DayData.length; i++) {
					dayOptionsItems.push({
						id: data.DayData[i],
						text: data.DayData[i]
					});
				}
				const yearOptionsItems = [];
				for (let i = 0; i < data.YearData.length; i++) {
					yearOptionsItems.push({
						id: data.YearData[i],
						text: data.YearData[i]
					});
				}
				const countryOptionsItems = [];
				for (let i = 0; i < data.CountryData.length; i++) {
					countryOptionsItems.push({
						id: data.CountryData[i].CountryID,
						text: data.CountryData[i].CountryName
					});
				}
				// call api to get Occupation & Source of Funds
				// const OccupationOptionItems = [];
				// for (let i = 0; i < data.OccupationData.length; i++) {
				// 	OccupationOptionItems.push({
				// 		id: data.OccupationData[i].OccupationID,
				// 		text: data.OccupationData[i].OccupationName
				// 	});
				// }
				const currencyOptionsItems = [];
				for (let i = 0; i < data.CurrencyData.length; i++) {
					currencyOptionsItems.push({
						id: data.CurrencyData[i].CurrencyID,
						text: data.CurrencyData[i].CurrencyName
					});
				}
				const oddsOptionsItems = [];
				for (let i = 0; i < data.OddsData.length; i++) {
					oddsOptionsItems.push({
						id: data.OddsData[i].ItemArray[2],
						text: data.OddsData[i].ItemArray[1]
					});
				}
				const bCountryOptionsItems = [];
				for (let i = 0; i < data.BankCountryData.length; i++) {
					bCountryOptionsItems.push({
						id: data.BankCountryData[i].CountryID,
						text: data.BankCountryData[i].CountryName
					});
				}
				const bNameOptionsItems = [];
				if (data.txtCurrency != '') {
					for (let i = 0; i < data.BankNameData.length; i++) {
						if (data.BankNameData[i].CurrencyId == data.txtCurrency) {
							bNameOptionsItems.push({
								id: data.BankNameData[i].CurrencyId,
								text: data.BankNameData[i].BankedIn
							});
						}
					}
				}
				this.setState({
					sqOptionsItems: sqOptionsItems,
					OccupationOptionItems: OccupationOptionsItems,
					FundsOptionsItems: SourceFundsOptionsItems,
					monthOptionsItems: monthOptionsItems,
					dayOptionsItems: dayOptionsItems,
					yearOptionsItems: yearOptionsItems,
					countryOptionsItems: countryOptionsItems,
					currencyOptionsItems: currencyOptionsItems,
					oddsOptionsItems: oddsOptionsItems,
					bCountryOptionsItems: bCountryOptionsItems,
					bNameOptionsItems: bNameOptionsItems,
					bNameData: data.BankNameData,
					lbl_OpenAccount: data.lbl_OpenAccount,
					lbl_Preferred_username: data.lbl_Preferred_username,
					lbl_checkusername: data.lbl_checkusername,
					lbl_password: data.lbl_password,
					lbl_confirmpassword: data.lbl_confirmpassword,
					lbl_Securitycode: data.lbl_Securitycode,
					lbl_SecurityAnswer: data.lbl_SecurityAnswer,
					lbl_execlastname: data.lbl_execlastname,
					lbl_firstname: data.lbl_firstname,
					lbl_lastname: data.lbl_lastname,
					lbl_Dateofbirth: data.lbl_Dateofbirth,
					lbl_Country: data.lbl_Country,
					lbl_email: data.lbl_email,
					lbl_Primaryphone: data.lbl_Primaryphone,
					lbl_My_Preferred_currency: data.lbl_My_Preferred_currency,
					lbl_My_Preferred_odds: data.lbl_My_Preferred_odds,
					lbl_BonusCode: data.lbl_BonusCode,
					lbl_BankCountry: data.lbl_BankCountry,
					lbl_code: data.lbl_code,
					lbl_regNote1: data.lbl_regNote1,
					lbl_regNote4: data.lbl_regNote4,
					lbl_regNote5: data.lbl_regNote5,
					lbl_regNote6: data.lbl_regNote6,
					lbl_BankName: data.lbl_BankName,
					lbl_BankAddress: data.lbl_BankAddress,
					lbl_Branch: data.lbl_Branch,
					lbl_BankAccountNumber: data.lbl_BankAccountNumber,
					lbl_BankSwift: data.lbl_BankSwift,
					lbl_AccountName: data.lbl_AccountName,
					lbl_Corresponding: data.lbl_Corresponding,
					lbl_WhereToKnowMsg: data.lbl_WhereToKnowMsg,
					lbl_AgentCode: data.lbl_AgentCode,
					lbl_SelectYear: data.Year,
					lbl_SelectMonth: data.Month,
					lbl_SelectDay: data.Day,
					Month: data.Month,
					Day: data.Day,
					Year: data.Year,
					displayWhereToKnow: data.displayWhereToKnow,
					DisCtl_AgentCode: data.DisCtl_AgentCode,
					DisCtl_BankDetail: data.DisCtl_BankDetail,
					FundoutBankDetail: data.FundoutBankDetail,
					BankNameStyle: data.BankNameStyle,
					BankAddressStyle: data.BankAddressStyle,

					BankAddress_Required: data.BankAddress_Required,
					BankCountry_Required: data.BankCountry_Required,
					Branch_Required: data.Branch_Required,
					BankSwift_Required: data.BankSwift_Required,
					BankCorr_Required: data.BankCorr_Required,

					BankCountryStyle: data.BankCountryStyle,
					BranchStyle: data.BranchStyle,
					CanSeeAccountName: data.CanSeeAccountName,
					AccountNumberStyle: data.AccountNumberStyle,
					BankSwiftStyle: data.BankSwiftStyle,
					BankCorrBankStyle: data.BankCorrBankStyle,
					FirstNameStyle: data.FirstNameStyle,
					LastNameStyle: data.LastNameStyle,
					markBankName: data.markBankName,
					markBankAddress: data.markBankAddress,
					markBankCountry: data.markBankCountry,
					markBranch: data.markBranch,
					markAccountName: data.markAccountName,
					markBankAccoun: data.markBankAccoun,
					markBank_swift: data.markBank_swift,
					markCorrespondingBank: data.markCorrespondingBank,
					markFirstName: data.markFirstName,
					markLastName: data.markLastName,
					txtFirstName: data.txtFirstName,
					txtLastName: data.txtLastName,
					DisCtl_Bonus: data.DisCtl_Bonus,
					styleMy_Country: data.styleMy_Country,
					styleMy_Preferred_odds: data.styleMy_Preferred_odds,
					styleMy_Preferred_currency: data.styleMy_Preferred_currency,
					displayDateofbirth: data.displayDateofbirth,
					displaySecurityAnswer: data.displaySecurityAnswer,
					displaySecuritycode: data.displaySecuritycode,
					Currency: data.Currency,
					txtCurrency: data.txtCurrency,
					Odds: data.Odds,
					txtOdds: data.txtOdds,
					Country: data.Country,
					txtCountry: data.txtCountry,
					SubmitStyle: data.SubmitStyle,
					AffID: data.AffID,
					ClickID: data.ClickID,
					lbl_Address: data.lbl_Address,
					lbl_Occupation: data.lbl_Occupation,
					lbl_SourceofFunds: data.lbl_SourceofFunds,
					Occupation: data.DefaultOccupationSelect,
					SourceFunds: data.DefaultSourceFundsSelect,
					lbl_OtherOption: data.lbl_OtherOption,
					lbl_SourceFunds: data.lbl_SourceFunds,
					lbl_Limit50: data.Limit50,
					lbl_limit200: data.Limit200,
					lbl_RegistrationField27: data.lbl_RegistrationField27,
					lbl_RegistrationField28: data.lbl_RegistrationField28,
					lbl_RegistrationField29: data.lbl_RegistrationField29,
					lbl_RegistrationField30: data.lbl_RegistrationField30,
					lbl_RegistrationField31: data.lbl_RegistrationField31,
					lbl_RegistrationField32: data.lbl_RegistrationField32,
					lbl_RegistrationField33: data.lbl_RegistrationField33,
					lbl_RegistrationField34: data.lbl_RegistrationField34,
					lbl_RegistrationField35: data.lbl_RegistrationField35,
					lbl_RegistrationField36: data.lbl_RegistrationField36,
					lbl_RegistrationField37: data.lbl_RegistrationField37,
					lbl_RegistrationField38: data.lbl_RegistrationField38,
					lbl_RegistrationField39: data.lbl_RegistrationField39,
					lbl_RegistrationField40: data.lbl_RegistrationField40,

				});
			}
		});
	}

	render() {
		let //self = this,
			SQOption,
			MonthOption,
			DayOption,
			YearOption,
			CountryOption,
			CurrencyOption,
			OddsOption,
			BankNameOption,
			BankCountryOption,
			SourceFundsOption,
			OccupationOption;

		const { KycfileError, KycFileInfo, KycfileErrorMessage } = this.state;
		if (this.state.displaySecuritycode) {
			SQOption = this.state.sqOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'SQ',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
		}


		if (isAudit) {
			OccupationOption = this.state.OccupationOptionItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'Occupation',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
		}

		if (isAudit) {
			SourceFundsOption = this.state.FundsOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'SourceFunds',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
		}
		if (this.state.displayDateofbirth == '') {
			MonthOption = this.state.monthOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'Month',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
			DayOption = this.state.dayOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'Day',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
			YearOption = this.state.yearOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'Year',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
		}
		if (this.state.styleMy_Country) {
			CountryOption = this.state.countryOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'Country',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
		}
		if (this.state.styleMy_Preferred_currency) {
			CurrencyOption = this.state.currencyOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'Currency',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
		}
		if (this.state.styleMy_Preferred_odds) {
			OddsOption = this.state.oddsOptionsItems.map((item, i) => {
				const oItemProperty = {
					key: i,
					type: 'Odds',
					id: item.id,
					text: item.text,
					onClick: this.onSelectClick
				};
				return <OptionItem {...oItemProperty} />;
			});
		}
		if (this.state.DisCtl_BankDetail == '') {
			if (this.state.BankNameStyle && this.state.FundoutBankDetail) {
				BankNameOption = this.state.bNameOptionsItems.map((item, i) => {
					const oItemProperty = {
						key: i,
						type: 'BankName',
						id: item.text,
						text: item.text,
						onClick: this.onSelectClick
					};
					return <OptionItem {...oItemProperty} />;
				});
			}
			if (this.state.BankCountryStyle) {
				BankCountryOption = this.state.bCountryOptionsItems.map((item, i) => {
					const oItemProperty = {
						key: i,
						type: 'BankCountry',
						id: item.id,
						text: item.text,
						onClick: this.onSelectClick
					};
					return <OptionItem {...oItemProperty} />;
				});
			}
		}
		return (
			<div className="blocker">
				<div className="modal popup-signup">
					<a
						href="javascript:void(0);"
						onClick={this.popupDiv.bind(this, -1)}
						title="Close"
						className="close"
					>
						<i className="icon-close" />
					</a>
					<h2>{this.state.lbl_OpenAccount}</h2>
					<div className="one-row">
						<div className="one-three">
							<label>
								<span className="mark">*</span>
								{this.state.lbl_Preferred_username}
								<input
									id="username"
									name="txtUserName"
									type="text"
									autoComplete="on"
									className="box-bg"
									onChange={this.handleInputChange}
									value={this.state.txtUserName}
								/>
								<a
									id="lnkCheckUserName"
									className="cont12oe"
									name="lnkCheckUserName"
									onClick={this.checkUserName}
									styles="margin-top: 5px;cursor: pointer;"
								>
									{this.state.lbl_checkusername}
								</a>
							</label>
							<label>
								<span className="mark">*</span>
								{this.state.lbl_password}
								<input
									id="txtPassword"
									name="txtPassword"
									size="30"
									type="password"
									className="box-bg"
									onChange={this.handleInputChange}
									value={this.state.txtPassword}
								/>
							</label>
							<label>
								<span className="mark">*</span>
								{this.state.lbl_confirmpassword}
								<input
									id="txtConfirm_Password"
									name="txtConfirmPassword"
									size="30"
									type="password"
									className="box-bg"
									onChange={this.handleInputChange}
									value={this.state.txtConfirmPassword}

								/>
							</label>
							{this.state.displaySecuritycode && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_Securitycode}
									<div
										id="divSecurity_Question"
										className="dropDown box-bg"
										onMouseOver={this.showOptions.bind(this, 'SQ')}
										onMouseOut={this.hiddenOptions.bind(this, 'SQ')}
									>
										<span>{this.state.SQ}</span>
										<ul id="sQuestionID_submenu" className={'submenu ' + this.state.showSQOption}>
											{SQOption}
										</ul>
									</div>
								</label>
							)}
							{this.state.displaySecurityAnswer && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_SecurityAnswer}
									<input
										id="txtSecurity_code"
										name="txtQuestionCode"
										type="text"
										autoComplete="on"
										className="box-bg"
										size="30"
										onChange={this.handleInputChange}
										value={this.state.txtQuestionCode}
									/>
								</label>
							)}
							<div className="two-box-input">
								{(this.state.FirstNameStyle || this.state.LastNameStyle) && (
									<div className="ps">{this.state.lbl_execlastname}</div>
								)}
								{this.state.FirstNameStyle && (
									<label>
										<span className={'mark ' + this.state.markFirstName}>*</span>
										{this.state.lbl_firstname}
										<input
											id="txtFirst_name"
											name="txtFirstName"
											type="text"
											size="20"
											autoComplete="on"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtFirstName}
										/>
									</label>
								)}
								{this.state.LastNameStyle && (
									<label>
										<span className={'mark ' + this.state.markLastName}>*</span>
										{this.state.lbl_lastname}
										<input
											id="txtLast_name"
											name="txtLastName"
											type="text"
											size="20"
											autoComplete="on"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtLastName}
										/>
									</label>
								)}

							</div>
							{
								isAudit &&
								(


									<div className="audit" >
										<label>
											<span class="mark">*</span>{this.state.lbl_RegistrationField27}
										</label>
										{
											(!KycFileInfo.preview && !KycfileError)
											&&
											<div className="audit__browse" onClick={this.handleBrowseClick}>
												<span className="audit__browse-text">{this.state.lbl_RegistrationField28}</span>
												<div className="audit__icon-file">
												</div>
											</div>
										}
										{
											KycfileError ?
												<div className="audit__file">
													<div className="audit__file-group">
														<div className="audit__icon-warning"></div>
														<span className="audit__error-text">{KycfileErrorMessage}</span>
													</div>
													<div className="audit__file-btn" onClick={this.handleBrowseClick}>{this.state.lbl_RegistrationField38}</div>
												</div> :
												KycFileInfo.preview && (
													<div className="audit__file">
														<div className="audit__file-group">
															<div className="audit__file-img">
																<img id="file-preview" src={KycFileInfo.preview} alt="File Preview" />
															</div>
															<span id="file-name" className="audit__file-title">{KycFileInfo.name}</span>
															<span id="file-size" className="audit__file-text">{KycFileInfo.size}</span>
														</div>
														<div className="audit__file-btn" onClick={this.handleBrowseClick}>{this.state.lbl_RegistrationField38}</div>
														<div className="audit__icon-clear" onClick={this.clearFile}></div>
													</div>
												)
										}

										<div className="audit__item">
											<div className="audit__item-title">{`${this.state.lbl_RegistrationField28}`}</div>
											<ul>
												<li>{this.state.lbl_RegistrationField30}</li>
												<li>{this.state.lbl_RegistrationField31}</li>
												<li>{this.state.lbl_RegistrationField32}</li>
												<li>{this.state.lbl_RegistrationField33}</li>
												<li>{this.state.lbl_RegistrationField34}</li>
											</ul>
										</div>
										<input
											id="file-upload"
											name="KycFileInfo"
											type="file"
											ref={this.KycFileInputRef}
											className="audit__input-file"
											accept=".jpg,.png"
											style={{ display: 'none' }}
											onChange={this.handleFileChange}
										/>
									</div>

								)
							}
						</div>
						<div className="one-three">
							<div className={'three-box ' + this.state.displayDateofbirth}>
								<div className="txt">
									<span className="mark">*</span>
									{this.state.lbl_Dateofbirth}
								</div>
								<div className="dropDown-group">
									<div
										id="divSelmon"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'Month')}
										onMouseOut={this.hiddenOptions.bind(this, 'Month')}
										styles="display: inline-block\0; float: none\0;"
									>
										<span>{this.state.Month}</span>
										<ul id="Selmon_submenu" className={'submenu ' + this.state.showMonthOption}>
											{MonthOption}
										</ul>
									</div>
									<div
										id="divtxtday"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'Day')}
										onMouseOut={this.hiddenOptions.bind(this, 'Day')}
										styles="display: inline-block\0; float: none\0;"
									>
										<span>{this.state.Day}</span>
										<ul id="txtday_submenu" className={'submenu ' + this.state.showDayOption}>
											{DayOption}
										</ul>
									</div>
									<div
										id="divtxtyear"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'Year')}
										onMouseOut={this.hiddenOptions.bind(this, 'Year')}
										styles="display: inline-block\0; float: none\0;"
									>
										<span>{this.state.Year}</span>
										<ul id="txtyear_submenu" className={'submenu ' + this.state.showYearOption}>
											{YearOption}
										</ul>
									</div>
								</div>
								{(_SiteId === "4218400") && <div className="ps">{Label.lbl_IvoryBetAge21Check}</div>}
							</div>
							{this.state.styleMy_Country && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_Country}
									<div
										id="divselCountry"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'Country')}
										onMouseOut={this.hiddenOptions.bind(this, 'Country')}
									>
										<span>{this.state.Country}</span>
										<ul
											id="selCountry_submenu"
											className={'submenu ' + this.state.showCountryOption}
										>
											{CountryOption}
										</ul>
									</div>
								</label>
							)}
							{
								isAudit && (
									<label>
										<span className="mark">*</span>{this.state.lbl_Address}
										<input
											id="txtAddress"
											name="txtAddress"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtAddress}
										/>
									</label>

								)
							}

							<label>
								<span className="mark">*</span>
								{this.state.lbl_email}
								<input
									id="txtEmail_address"
									name="txtEmail"
									className="box-bg"
									onChange={this.handleInputChange}
									value={this.state.txtEmail}
								/>
							</label>
							<label>
								<span className="mark">*</span>
								{this.state.lbl_Primaryphone}
								<input
									id="txtPrimary_phone"
									name="txtPhone"
									className="box-bg"
									onChange={this.handleInputChange}
									value={this.state.txtPhone}
								/>
							</label>
							{this.state.styleMy_Preferred_currency && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_My_Preferred_currency}
									<div
										id="divselcurrency"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'Currency')}
										onMouseOut={this.hiddenOptions.bind(this, 'Currency')}
									>
										<span>{this.state.Currency}</span>
										<ul
											id="selcurrency_submenu"
											className={'submenu ' + this.state.showCurrencyOption}
										>
											{CurrencyOption}
										</ul>
									</div>
								</label>
							)}
							{isAudit && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_Occupation}
									<div
										id="divselOccupation"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'Occupation')}
										onMouseOut={this.hiddenOptions.bind(this, 'Occupation')}
									>
										<span>{this.state.Occupation}</span>
										<ul
											id="selOccupation_submenu"
											className={'submenu ' + this.state.showOccupationOption}
										>
											{OccupationOption}
										</ul>
									</div>
									{this.state.ShowOccupationOtherText &&
										<input
											id="txtOccupationOther"
											name="txtOccupationOther"
											value={this.state.txtOccupationOther}
											type={!this.state.ShowOccupationOtherText ? 'hidden' : ''}
											placeholder={this.state.lbl_OtherOption}
											className="box-bg box-bg--space"
											onChange={this.handleInputChange} />
									}

								</label>
							)}

							{isAudit && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_SourceofFunds}
									<div
										id="divselsourceOfFunds"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'SourceFunds')}
										onMouseOut={this.hiddenOptions.bind(this, 'SourceFunds')}
									>
										<span>{this.state.SourceFunds}</span>
										<ul id="selsourceOfFunds_submenu"
											className={'submenu ' + this.state.showSourceFundsOption}>
											{SourceFundsOption}
										</ul>
									</div>
									{this.state.ShowSourceFundsOtherText &&
										<input
											id="txtSourceFundsOther"
											name="txtSourceFundsOther"
											value={this.state.txtSourceFundsOther}
											type={!this.state.ShowSourceFundsOtherText ? 'hidden' : ''}
											placeholder={this.state.lbl_SourceFunds}
											className="box-bg box-bg--space"
											onChange={this.handleInputChange} />
									}


								</label>
							)}

							{this.state.styleMy_Preferred_odds && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_My_Preferred_odds}
									<div
										id="divselPreferredodds"
										className="dropDown"
										onMouseOver={this.showOptions.bind(this, 'Odds')}
										onMouseOut={this.hiddenOptions.bind(this, 'Odds')}
									>
										<span>{this.state.Odds}</span>
										<ul
											id="selPreferredodds_submenu"
											className={'submenu ' + this.state.showOddsOption}
										>
											{OddsOption}
										</ul>
									</div>
								</label>
							)}
							{this.state.DisCtl_Bonus && (
								<label>
									{this.state.lbl_BonusCode}
									<input
										id="txtBonusCode"
										name="txtBonusCode"
										size="20"
										type="text"
										autoComplete="on"
										className="box-bg"
										onChange={this.handleInputChange}
										value={this.state.txtBonusCode}
									/>
								</label>
							)}
							{this.state.DisCtl_AgentCode && (
								<label>
									{this.state.lbl_AgentCode}
									<input
										id="txtAgentCode"
										name="txtAgentCode"
										size="20"
										type="text"
										autoComplete="on"
										className="box-bg"
										onChange={this.handleInputChange}
										value={this.state.txtAgentCode}
									/>
								</label>
							)}
							{this.state.displayWhereToKnow && (
								<label>
									<span className="mark">*</span>
									{this.state.lbl_WhereToKnowMsg}
									<input
										id="txtWhereToKnow"
										name="txtWhereToKnow"
										size="30"
										type="text"
										autoComplete="on"
										className="box-bg"
										onChange={this.handleInputChange}
										value={this.state.txtWhereToKnow}
									/>
								</label>
							)}
						</div>
						<div className="one-three">
							{this.state.DisCtl_BankDetail == '' &&
								this.state.BankNameStyle && (
									<label>
										<span className={'mark ' + this.state.markBankName}>*</span>
										{this.state.lbl_BankName}
										{this.state.FundoutBankDetail ? (
											<div
												id="bankName"
												className="dropDown"
												onMouseOver={this.showOptions.bind(this, 'BankName')}
												onMouseOut={this.hiddenOptions.bind(this, 'BankName')}
											>
												<span>{this.state.BankName}</span>
												<ul
													id="bankName_submenu"
													className={'submenu ' + this.state.showBankNameOption}
												>
													{BankNameOption}
												</ul>
											</div>
										) : (
											<input
												name="txtBankName"
												id="txtBank_Name"
												size="30"
												className="box-bg"
												onChange={this.handleInputChange}
												value={this.state.txtBankName}
											/>
										)}
									</label>
								)}
							{this.state.DisCtl_BankDetail == '' &&
								this.state.BankAddressStyle && (
									<label>
										<span className={'mark ' + this.state.markBankAddress}>*</span>
										{this.state.lbl_BankAddress}
										<input
											id="txtBankAddress"
											name="txtBankAddress"
											size="30"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtBankAddress}
										/>
									</label>
								)}
							{this.state.DisCtl_BankDetail == '' &&
								this.state.BankCountryStyle && (
									<label>
										<span className={'mark ' + this.state.markBankCountry}>*</span>
										{this.state.lbl_BankCountry}
										<div
											id="bankName"
											className="dropDown"
											onMouseOver={this.showOptions.bind(this, 'BankCountry')}
											onMouseOut={this.hiddenOptions.bind(this, 'BankCountry')}
										>
											<span>{this.state.BankCountry}</span>
											<ul
												id="selBankCountry_submenu"
												className={'submenu ' + this.state.showBankCountryOption}
											>
												{BankCountryOption}
											</ul>
										</div>
									</label>
								)}
							{this.state.DisCtl_BankDetail == '' &&
								this.state.BranchStyle && (
									<label>
										<span className={'mark ' + this.state.markBranch}>*</span>
										{this.state.lbl_Branch}
										<input
											id="txtBranch"
											name="txtBranch"
											size="30"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtBranch}
										/>
									</label>
								)}
							{this.state.DisCtl_BankDetail == '' &&
								this.state.CanSeeAccountName && (
									<label>
										<span className={'mark ' + this.state.markAccountName}>*</span>
										{this.state.lbl_AccountName}
										<input
											id="txtAccountName"
											name="txtAccountName"
											size="30"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtAccountName}
										/>
									</label>
								)}
							{this.state.DisCtl_BankDetail == '' &&
								this.state.AccountNumberStyle && (
									<label>
										<span className={'mark ' + this.state.markBankAccoun}>*</span>
										{this.state.lbl_BankAccountNumber}
										<input
											id="txtBankAccount"
											name="txtBankAccount"
											size="30"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtBankAccount}
										/>
									</label>
								)}
							{this.state.DisCtl_BankDetail == '' &&
								this.state.BankSwiftStyle && (
									<label>
										<span className={'mark ' + this.state.markBank_swift}>*</span>
										{this.state.lbl_BankSwift}
										<input
											id="txtBank_swift"
											name="txtBank_swift"
											size="30"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtBank_swift}
										/>
									</label>
								)}
							{this.state.DisCtl_BankDetail == '' &&
								this.state.BankCorrBankStyle && (
									<label>
										<span className={'mark ' + this.state.markCorrespondingBank}>*</span>
										{this.state.lbl_Corresponding}
										<input
											id="txtCorresponding_Bank"
											name="txtCorresponding_Bank"
											size="30"
											className="box-bg"
											onChange={this.handleInputChange}
											value={this.state.txtCorresponding_Bank}
										/>
									</label>
								)}
							<label className="validation">
								<span className="mark">*</span>
								{this.state.lbl_code}
								<input
									name="txtValidation"
									id="txtValidation"
									className="input box-bg"
									onChange={this.handleInputChange}
									value={this.state.txtValidation}
								/>
								<img src="registration_code.aspx" width="40" height="22" align="absmiddle" />
							</label>
							<label htmlFor="CheckTerm" className="small-input">
								<span className="mark">*</span>
								<input
									type="checkbox"
									name="CheckTerm"
									className=""
									id="CheckTerm"
									onChange={this.handleInputChange}
									value={this.state.CheckTerm}
								/>
								<div className="txt">{this.state.lbl_regNote1}{
									<span dangerouslySetInnerHTML={{ __html: this.state.lbl_regNote6 }}>
									</span>
								}</div>


							</label>
						</div>
					</div>
					<div className={'btn btn-primary-gradient btn-block btn-large ' + this.state.SubmitStyle} onClick={this.senRegister}>
						{Label.lbl_Submit}
					</div>
					<div className="txt">{this.state.lbl_regNote4}</div>
					<div className="txt">{this.state.lbl_regNote5}</div>
				</div>
			</div>
		);
	}
}
